import { createSlice } from '@reduxjs/toolkit'
import { addNewRoleWithPermissions, addPermissions, getallPermissions, getPermissionsForRole, getRoles } from '../../builders/roleManagement/rolemanagement.builder'

const initialState = {
  roleId: '',
  loading: false,
  roleData: [],
  allPermissions: [],
  permissionsFormRole: []
}

const roleManagementSlice = createSlice({
  name: 'roleManagement',
  initialState: initialState,
  reducers: {

    clearExtraReducers: (state) => {
      state.roleId = '';
      state.loading = false;
      state.roleData = [];
      state.allPermissions = [];
      state.permissionsFormRole = [];
    }

  },

  extraReducers: (builder) => {
    builder.addCase(getRoles.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.loading = false
      state.roleData = action.payload
    })
    builder.addCase(getRoles.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getallPermissions.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getallPermissions.fulfilled, (state, action) => {
      state.loading = false
      state.allPermissions = action.payload
    })
    builder.addCase(getallPermissions.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(addPermissions.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addPermissions.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(addPermissions.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getPermissionsForRole.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getPermissionsForRole.fulfilled, (state, action) => {
      state.loading = false
      state.permissionsFormRole = action.payload
    })
    builder.addCase(getPermissionsForRole.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(addNewRoleWithPermissions.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addNewRoleWithPermissions.fulfilled, (state) => {
      state.loading = false
      // state.permissionsFormRole = action.payload
    })
    builder.addCase(addNewRoleWithPermissions.rejected, (state) => {
      state.loading = false
    })

  },
})

export const { clearExtraReducers } = roleManagementSlice.actions

// export const {} = studentSlice.actions

export default roleManagementSlice.reducer
